import React from 'react';
import CustomNavbar from '../components/Navbar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CarouselS from '../components/Carousel-s';
import "../css/sectionLR.css";

  const slides1 = ["/images/cheese_1.gif","/images/oils---fats_1.gif","/images/oils---fats_2.gif","/images/soya_bean_oil_1.gif","/images/soya_bean_oil_2.gif","/images/sunflower-oil_1.gif"]
  const slides2 = ["/images/milk_01.gif","/images/milk_02.gif","/images/milk_03.gif"]


function Products() {

    return(
    <div>
        <CustomNavbar />
        <Header 
      title = "OUR PRODUCTS"
      subtext = "Eastern for Trading offers a diverse range of high-quality products for the food industry, with a strong commitment to quality and reliability. Our product portfolio includes premium oils and fats, as well as a wide range of dairy and milk products."
      imgURL = "/images/melted-chocolate-swirl.jpg"
    />

        <div className={"section "}>

            <div className="text dm1">
              <h3>OIL & FAT PRODUCTS</h3>
                           
              <ul>
                <li>Cocoa Butter Equivalent (CBE) Palmy MM7</li>
                <li>Cocoa Butter Substitute (CBS) Palkena H2</li>
                <li>Shortening</li>
                <li>Palm Olein IV56 / IV58 (For Potato Chips factory)</li>
                <li>Super Olein for specialty IV62</li>
                <li>Sunflower Oil</li>
              </ul>
            </div>

        <CarouselS items={slides1} interval={3000}/>

        </div>

                <div className={"section "}>

            <div className="text dm1">
              <h3>MILK PRODUCTS</h3>
                           
              <ul>
                <li>Skimmed Milk Powder</li>
                <li>Whey Milk Powder</li>

              </ul>
            </div>

        <CarouselS items={slides2} interval={3000}/>

        </div>


        <Footer />
    </div>
    )
}

export default Products;

